import React from 'react';
import { steps } from '../data/content';
export function HowItWorks() {
  return <section className="border-b border-steelLine bg-steel px-4 py-8 sm:py-10" data-id="element-95" data-mp="7slq0yyp41rl">
      <div className="mx-auto max-w-4xl" data-id="element-96" data-mp="7qiqnobnkwa7">
        <h2 className="text-center text-xl text-white sm:text-3xl" data-id="element-97" data-mp="3pz9pa872dupc">How It Works</h2>
        <ol className="mt-4 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-98" data-mp="3tzjz5vxz959h">
          {steps.map(step => <li key={step.number} className="rounded-md border border-steelLine bg-charcoal p-3.5" data-id="element-99" data-mp="lk09t80fg6zp">
              <span className="font-display text-2xl font-black text-gold" data-id="element-100" data-mp="qjmm9f8flj7g">{step.number}</span>
              <h3 className="mt-1 text-sm text-white sm:text-base" data-id="element-101" data-mp="csrlyrc00afh">{step.title}</h3>
              <p className="mt-1 text-sm font-medium leading-snug text-lightGray" data-id="element-102" data-mp="gtbiptsntc13">{step.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}